import { render, staticRenderFns } from "./ButtonCertify.vue?vue&type=template&id=5a0cab66&"
import script from "./ButtonCertify.vue?vue&type=script&lang=js&"
export * from "./ButtonCertify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports